import React from 'react'
import Navbar from './NavbarComponent/Navbar'
import Hero from './HomePage/Hero'
import About from './AboutSection/About'
import Division from './CardSection/Division'

import WorkShowcase from './WorkShowcase/WorkShowcase'
import SectionAbout from './AboutPage/SectionAbout'
import WhatsApp from './WhatsApp/WhatsApp'
import ScrollToTop from './ScrollToTop'
import Contact from './ContactPage/Contact'
import Footer from './Footer/Footer'

function App() {
  return (
    <div>
      <WhatsApp/>
      <ScrollToTop/>
      <Navbar/>
      <Hero/>
      <WorkShowcase/>
      <SectionAbout/>
      <About/>
      <Division/>
      <Contact/>
      <Footer/>
      
    </div>
  )
}

export default App